var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    opacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.191,13.048l0,0L16.951.809a2.761,2.761,0,0,0-3.906,0L.814,13.039.8,13.052A2.761,2.761,0,0,0,2.64,17.757q.042,0,.085,0h.488v9.006A3.236,3.236,0,0,0,6.445,30h4.788a.879.879,0,0,0,.879-.879V22.06a1.476,1.476,0,0,1,1.475-1.475H16.41a1.476,1.476,0,0,1,1.475,1.475V29.12a.879.879,0,0,0,.879.879h4.788a3.236,3.236,0,0,0,3.233-3.232V17.761h.452a2.762,2.762,0,0,0,1.954-4.714Zm0,0",
    transform: "translate(18 17.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.e849f2077dbcdd72290464ddba8e62e0.svg";
export { ForwardRef as ReactComponent };